import { CreditNoteKind, CreditNoteState } from "@oysterhr/schema"
import { BadgeStateItem } from "~/shared/components/StatesDescription"

export const PER_PAGE = 10

export const CreditNoteStateLabelsMap: Record<CreditNoteState, BadgeStateItem> = {
  [CreditNoteState.Draft]: {
    variation: "gray",
    translationKey: "state.draft.title",
    descriptionKey: "state.draft.description",
  },
  [CreditNoteState.Refunded]: {
    variation: "success",
    translationKey: "state.refunded.title",
    descriptionKey: "state.refunded.description",
    tooltipKey: "state.refunded.tooltip",
  },
  [CreditNoteState.Applied]: {
    variation: "success",
    translationKey: "state.applied.title",
    descriptionKey: "state.applied.description",
  },
  [CreditNoteState.PartiallyApplied]: {
    variation: "success",
    translationKey: "state.partiallyApplied.title",
    descriptionKey: "state.partiallyApplied.description",
  },
  [CreditNoteState.Issued]: {
    variation: "warning",
    translationKey: "state.issued.title",
    descriptionKey: "state.issued.description",
  },
  [CreditNoteState.Voided]: {
    variation: "error",
    translationKey: "state.voided.title",
    descriptionKey: "state.voided.description",
  },
  [CreditNoteState.Processing]: {
    variation: "info",
    translationKey: "state.processing.title",
    descriptionKey: "state.processing.description",
    tooltipKey: "state.processing.tooltip",
  },
  [CreditNoteState.RefundFailed]: {
    variation: "error",
    translationKey: "state.refundFailed.title",
    descriptionKey: "state.refundFailed.description",
    tooltipKey: "state.refundFailed.tooltip",
  },
}

export const CreditNoteKindLabelsMap: Record<
  CreditNoteKind,
  Pick<BadgeStateItem, "translationKey">
> = {
  [CreditNoteKind.Manual]: { translationKey: "kind.manual.title" },
  [CreditNoteKind.ClosingInvoice]: { translationKey: "kind.closingInvoice.title" },
  [CreditNoteKind.PreFundingRefund]: { translationKey: "kind.preFundingRefund.title" },
  [CreditNoteKind.DepositRefund]: { translationKey: "kind.depositRefund.title" },
  [CreditNoteKind.CreditAdjustment]: { translationKey: "kind.creditAdjustment.title" },
}
